import { minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing } = theme;

export const partnerPageHeaderWrapper = css`
  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      background-color: var(--brand-purple-5);
    `,
  )}
`;

export const carouselContainer = css`
  margin: ${spacing.xl}px 0;
`;
